import { componentConfig, componentLoader } from "../../lib/component_initializer";
import DealsWidget from "./index";

export const DealsWidgetLoader = function (options = {}) {
  componentLoader(
    componentConfig(
      DealsWidget,
      DealsWidget.config.componentTypeKey,
      DealsWidget.config.baseHtmlClass
    ),
    options
  );
};
